function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.71292 0C9.23567 0 8.89338 0.387442 9.03051 0.772409L9.77822 2.87138C9.80839 2.95608 9.81596 3.04535 9.80038 3.1328L9.41242 5.311C9.34781 5.67376 9.68142 6 10.117 6H10.4893C10.7396 6 10.9715 5.88942 11.1002 5.7087L12.8985 3.1847C12.9835 3.0653 13.0166 2.9247 12.9921 2.78699L12.5867 0.510996C12.5344 0.217284 12.2348 0 11.8822 0H9.71292ZM2.5 8C2.5 7.44772 2.94772 7 3.5 7H18.5C19.0523 7 19.5 7.44772 19.5 8V9H22.5C22.7761 9 23 9.22386 23 9.5V14C23 16.7614 20.7614 19 18 19H16.4775C14.9982 20.2479 13.0869 21 11 21C6.30558 21 2.5 17.1944 2.5 12.5V8ZM19.5 12.5C19.5 14.1493 19.0303 15.6889 18.2173 16.9922C19.7727 16.8809 21 15.5838 21 14V11H19.5V12.5ZM1.4 22C1.17909 22 1 22.1791 1 22.4C1 23.2837 1.71635 24 2.6 24H19.4C20.2837 24 21 23.2837 21 22.4C21 22.1791 20.8209 22 20.6 22H1.4Z",
  fill: "currentColor"
});

var SvgDrinks = function SvgDrinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drinks.cf909541.svg";
export { ForwardRef as ReactComponent };